import hanabi from 'hanabi'

export function renderCode(code: string) {
  return hanabi(code)
}
